// --- IMAGE IMPORTS FOR PROJECTS & GALLERY ---
import VARK1 from '../images/VARK1.jpeg';
import VARK2 from '../images/VARK2.jpeg';
import VARK3 from '../images/VARK3.jpeg';
import VARK4 from '../images/VARK4.jpeg';
import VARK5 from '../images/VARK5.jpeg';
import VARK6 from '../images/VARK6.jpeg';
import VARK7 from '../images/VARK7.jpeg';
import VARK8 from '../images/VARK8.jpeg';
import VARK9 from '../images/VARK9.jpeg';
import VARK10 from '../images/VARK10.jpeg';
import VARK11 from '../images/VARK11.jpeg';
import VARK12 from '../images/VARK12.jpeg';
import MODERNHOUSE from '../images/MODERNHOUSE.jpeg';
import APPARTMENTS from '../images/APPARTMENTS.jpeg';
import INTERIOR from '../images/INTERIOR.jpeg';

/**
 * Multi-Level Hierarchy for Ongoing Projects:
 * Tier 1: Key Regional Cities in Tamil Nadu
 * Tier 2: Premium Sub-locations with Landmark Developments
 */
export const PROJECT_LOCATIONS = [
  {
    city: "Madurai",
    region: "Southern Hub (HQ)",
    count: 14,
    badge: "Core Hub",
    route: "/",
    subLocations: [
      {
        name: "Surya Nagar",
        projectName: "VARK Grand Royal Villas",
        type: "4 BHK Ultra-Luxury Villa",
        status: "Ongoing - 75% Completed",
        slug: "surya-nagar"
      },
      {
        name: "Oomachikulam",
        projectName: "VARK Emerald Enclave",
        type: "3 & 4 BHK Modern Duplex",
        status: "Finishing Stage",
        slug: "oomachikulam"
      },
      {
        name: "Avaniyapuram",
        projectName: "VARK Golden Heights",
        type: "3 BHK Premium Gated Living",
        status: "Ongoing - Structural Stage",
        slug: "avaniyapuram"
      },
      {
        name: "Thuvariman",
        projectName: "VARK Riverfront Retreat",
        type: "Luxury Turnkey Residence",
        status: "Ongoing - Brickwork Stage",
        slug: "thuvariman"
      },
      {
        name: "Koodal Nagar",
        projectName: "VARK Classic Homes",
        type: "Contemporary Independent Houses",
        status: "Ongoing - Plinth Level",
        slug: "koodal-nagar"
      },
      {
        name: "Tirunagar",
        projectName: "VARK Palm Meadows",
        type: "Custom Engineered Villas",
        status: "Ongoing - Framing Stage",
        slug: "tirunagar"
      }
    ]
  },
  {
    city: "Usilampatti",
    region: "Madurai District",
    route: "/usilampatti",
    count: 4,
    badge: "Top Builder",
    subLocations: [
      {
        name: "Peraiyur Road",
        projectName: "VARK Marutham Enclave",
        type: "3 BHK Modern Villa",
        status: "Ongoing - 80% Done",
        slug: "usilampatti-peraiyur"
      },
      {
        name: "Town Center",
        projectName: "VARK Golden Nest",
        type: "Budget Independent House",
        status: "Handover Ready",
        slug: "usilampatti-town"
      },
      {
        name: "Sedapatti Area",
        projectName: "VARK Green Acres",
        type: "Turnkey Farm Villa",
        status: "Ongoing - Roofing Stage",
        slug: "usilampatti-sedapatti"
      }
    ]
  },
  {
    city: "Karaikudi",
    region: "Sivaganga District",
    route: "/karaikudi",
    count: 5,
    badge: "Heritage Hub",
    subLocations: [
      {
        name: "Kalanivasal",
        projectName: "VARK Chettinad Heritage Villa",
        type: "4 BHK Courtyard Villa",
        status: "Ongoing - Roofing Stage",
        slug: "karaikudi-kalanivasal"
      },
      {
        name: "Sekkalai",
        projectName: "VARK Royal Palms",
        type: "Contemporary Residence",
        status: "Finishing Stage",
        slug: "karaikudi-sekkalai"
      },
      {
        name: "College Road",
        projectName: "VARK Alagappa Enclave",
        type: "3 BHK Premium Duplex",
        status: "Ongoing - Brickwork",
        slug: "karaikudi-college-rd"
      }
    ]
  },
  {
    city: "Sivaganga",
    region: "Sivaganga District",
    route: "/sivaganga",
    count: 4,
    badge: "District Hub",
    subLocations: [
      {
        name: "Madurai Road",
        projectName: "VARK Sivagangai Heights",
        type: "3 BHK Luxury Villa",
        status: "Ongoing - Plastering",
        slug: "sivaganga-madurai-rd"
      },
      {
        name: "Collectorate Area",
        projectName: "VARK Green Garden Home",
        type: "Turnkey Individual House",
        status: "Handover Ready",
        slug: "sivaganga-collectorate"
      },
      {
        name: "Manamadurai Highway",
        projectName: "VARK Highway Pearl",
        type: "Commercial & Residential",
        status: "Ongoing - Framing",
        slug: "sivaganga-highway"
      }
    ]
  },
  {
    city: "Thiruppuvanam",
    region: "Vaigai Corridor",
    route: "/thiruppuvanam",
    count: 3,
    badge: "Express Reach",
    subLocations: [
      {
        name: "Vaigai Riverfront",
        projectName: "VARK Vaigai Breeze Residences",
        type: "3 BHK Riverfront Villa",
        status: "Ongoing - 85% Completed",
        slug: "thiruppuvanam-vaigai"
      },
      {
        name: "Madurai Highway Road",
        projectName: "VARK Highway Crest",
        type: "Commercial & Residential",
        status: "Handover Ready",
        slug: "thiruppuvanam-highway"
      },
      {
        name: "Keezhadi Corridor",
        projectName: "VARK Heritage Enclave",
        type: "Traditional Villa Project",
        status: "Ongoing - Foundation",
        slug: "thiruppuvanam-keezhadi"
      }
    ]
  },
  {
    city: "Theni",
    region: "Theni District",
    route: "/theni",
    count: 5,
    badge: "Scenic Living",
    subLocations: [
      {
        name: "Periyakulam Road",
        projectName: "VARK Western Valley Mansions",
        type: "4 BHK Mountain View Villa",
        status: "Ongoing - 70% Completed",
        slug: "theni-periyakulam"
      },
      {
        name: "Theni Allinagaram",
        projectName: "VARK Green Meadow Homes",
        type: "3 BHK Contemporary Duplex",
        status: "Finishing Stage",
        slug: "theni-allinagaram"
      },
      {
        name: "Bodi Highway",
        projectName: "VARK Cardamom Hills Estate",
        type: "Scenic Luxury Bungalow",
        status: "Ongoing - Structural Stage",
        slug: "theni-bodi-hwy"
      }
    ]
  },
  {
    city: "Coimbatore",
    region: "Western Tamil Nadu",
    count: 8,
    badge: "Fast Track",
    subLocations: [
      {
        name: "RS Puram",
        projectName: "VARK Signature Mansions",
        type: "5 BHK Super-Luxury Villa",
        status: "Ongoing - Plinth & Slab",
        slug: "rs-puram"
      },
      {
        name: "Saravanampatti",
        projectName: "VARK Tech City Residences",
        type: "3 BHK High-Tech Villas",
        status: "Ongoing - First Floor",
        slug: "saravanampatti"
      },
      {
        name: "Gandhipuram",
        projectName: "VARK Elite Enclave",
        type: "Multi-Storey Luxury Apartments",
        status: "Ongoing - Excavation Stage",
        slug: "gandhipuram"
      },
      {
        name: "Peelamedu",
        projectName: "VARK Greenfield Villas",
        type: "Modern Gated Community",
        status: "Ongoing - Framing",
        slug: "peelamedu"
      }
    ]
  },
  {
    city: "Thanjavur",
    region: "Delta Heritage Zone",
    count: 6,
    badge: "Heritage Build",
    subLocations: [
      {
        name: "Medical College Road",
        projectName: "VARK Imperial Heritage",
        type: "Traditional & Modern Fusion Villas",
        status: "Ongoing - Brickwork & Roofing",
        slug: "medical-college-road"
      },
      {
        name: "New Bus Stand Area",
        projectName: "VARK Royal Enclave",
        type: "3 BHK Designer Homes",
        status: "Ongoing - Interior Finishing",
        slug: "new-bus-stand"
      },
      {
        name: "Vallam",
        projectName: "VARK Green Meadows",
        type: "Eco-Friendly Luxury Villas",
        status: "Ongoing - Foundation Ready",
        slug: "vallam"
      },
      {
        name: "Srinivasapuram",
        projectName: "VARK Serene Homes",
        type: "Turnkey Residential Houses",
        status: "Ongoing - Structural Stage",
        slug: "srinivasapuram"
      }
    ]
  },
  {
    city: "Kumbakonam",
    region: "Temple City & Riverfront",
    count: 5,
    badge: "Scenic Living",
    subLocations: [
      {
        name: "Swamimalai Road",
        projectName: "VARK Kaveri Riverview Villas",
        type: "3 BHK Serene Riverfront Villas",
        status: "Ongoing - Exterior Finishing",
        slug: "swamimalai-road"
      },
      {
        name: "Dharasuram",
        projectName: "VARK Temple Town Enclave",
        type: "Heritage Vastu Residences",
        status: "Ongoing - Plastering Stage",
        slug: "dharasuram"
      },
      {
        name: "Town Center",
        projectName: "VARK Central Manor",
        type: "Contemporary City Homes",
        status: "Ongoing - Second Floor",
        slug: "town-center"
      },
      {
        name: "Valangaiman Road",
        projectName: "VARK Orchid Villas",
        type: "Exclusive Independent Bungalows",
        status: "Ongoing - Foundation Stage",
        slug: "valangaiman-road"
      }
    ]
  },
  {
    city: "Trichy",
    region: "Central Tamil Nadu",
    count: 6,
    badge: "Urban Prime",
    subLocations: [
      {
        name: "Thillai Nagar",
        projectName: "VARK Pearl Residences",
        type: "4 BHK Contemporary Luxury Homes",
        status: "Ongoing - Structural Complete",
        slug: "thillai-nagar"
      },
      {
        name: "KK Nagar",
        projectName: "VARK Sunshine Enclave",
        type: "3 BHK Luxury Duplexes",
        status: "Ongoing - Brickwork",
        slug: "kk-nagar"
      },
      {
        name: "Cantonment",
        projectName: "VARK Royal Crest",
        type: "Executive Living Villas",
        status: "Ongoing - Plinth Stage",
        slug: "cantonment"
      }
    ]
  },
  {
    city: "Chennai",
    region: "Metro Capital Hub",
    count: 7,
    badge: "Metro Line",
    subLocations: [
      {
        name: "OMR - Sholinganallur",
        projectName: "VARK Silicon Villas",
        type: "Smart Automated Villas",
        status: "Ongoing - First Floor Slab",
        slug: "omr-sholinganallur"
      },
      {
        name: "Tambaram",
        projectName: "VARK Gateway Residences",
        type: "Gated Township Residences",
        status: "Ongoing - Framing",
        slug: "tambaram"
      },
      {
        name: "Porur",
        projectName: "VARK Westend Luxury Villas",
        type: "4 BHK High-End Homes",
        status: "Ongoing - Foundation Stage",
        slug: "porur"
      }
    ]
  }
];

/**
 * Detailed Featured Projects List for the Regional Showcase Section
 */
export const FEATURED_REGIONAL_PROJECTS = [
  {
    id: "madurai-surya-nagar",
    title: "VARK Grand Royal Villas",
    city: "Madurai",
    subLocation: "Surya Nagar",
    category: "Residential Luxury Villa",
    status: "Ongoing - 75% Completed",
    progress: 75,
    area: "3,450 sq.ft",
    bhk: "4 BHK Duplex",
    image: VARK1,
    description: "Architectural masterpiece in Madurai's prestigious Surya Nagar, featuring imported Italian marble, high ceilings, private landscaped garden, and smart home automation.",
    specs: ["Vastu 100% Compliant", "Private Swimming Pool", "Solar Powered", "2 Car Covered Parking"]
  },
  {
    id: "madurai-oomachikulam",
    title: "VARK Emerald Enclave",
    city: "Madurai",
    subLocation: "Oomachikulam",
    category: "Gated Villa Community",
    status: "Finishing Stage",
    progress: 90,
    area: "2,850 sq.ft",
    bhk: "3 & 4 BHK",
    image: VARK2,
    description: "Peaceful scenic community living located in Oomachikulam. Designed with modern minimalist facades, teak wood doors, and 24/7 security surveillance.",
    specs: ["Gated Township", "EV Charging Point", "Modular Teak Kitchen", "CCTV Surveillance"]
  },
  {
    id: "coimbatore-rs-puram",
    title: "VARK Signature Mansions",
    city: "Coimbatore",
    subLocation: "RS Puram",
    category: "Super-Luxury Residence",
    status: "Ongoing - Plinth & Slab",
    progress: 45,
    area: "4,600 sq.ft",
    bhk: "5 BHK Villa",
    image: VARK3,
    description: "An ultra-luxury mansion situated in prime RS Puram, Coimbatore. Highlights include double-height living areas, private rooftop sky terrace, and hydraulic elevator.",
    specs: ["Hydraulic Home Lift", "Sky Terrace Lounge", "Thermal Insulated Glass", "Landscape Courtyard"]
  },
  {
    id: "coimbatore-saravanampatti",
    title: "VARK Tech City Residences",
    city: "Coimbatore",
    subLocation: "Saravanampatti",
    category: "Modern Smart Villas",
    status: "Ongoing - First Floor",
    progress: 55,
    area: "2,600 sq.ft",
    bhk: "3 BHK Luxury",
    image: VARK4,
    description: "Engineered specifically for IT professionals along Coimbatore's thriving tech corridor. High-speed fiber cabling, automated lighting, and modern open-plan layouts.",
    specs: ["Smart Automation", "Clubhouse Access", "Rooftop Solar", "Rainwater Harvesting"]
  },
  {
    id: "thanjavur-medical-college",
    title: "VARK Imperial Heritage",
    city: "Thanjavur",
    subLocation: "Medical College Road",
    category: "Heritage Fusion Residence",
    status: "Ongoing - Brickwork & Roofing",
    progress: 60,
    area: "3,100 sq.ft",
    bhk: "4 BHK Villa",
    image: VARK5,
    description: "Merging timeless Chola architectural grandeur with cutting-edge structural engineering. Grand pillared entrance porch, central courtyard, and solid brass detailing.",
    specs: ["Pillared Heritage Porch", "Central Sky Courtyard", "Solid Teak Woodworks", "Deep Borewell Water"]
  },
  {
    id: "thanjavur-new-bus-stand",
    title: "VARK Royal Enclave",
    city: "Thanjavur",
    subLocation: "New Bus Stand Area",
    category: "Premium Duplex Villa",
    status: "Ongoing - Finishing Stage",
    progress: 85,
    area: "2,400 sq.ft",
    bhk: "3 BHK Duplex",
    image: VARK6,
    description: "Strategically positioned with easy transit access, offering expansive living halls, imported designer sanitary ware, and custom false-ceiling lighting.",
    specs: ["Prime Transit Access", "Full False Ceiling", "Premium Kohler Fittings", "Individual Sump & Bore"]
  },
  {
    id: "kumbakonam-swamimalai",
    title: "VARK Kaveri Riverview Villas",
    city: "Kumbakonam",
    subLocation: "Swamimalai Road",
    category: "Riverview Serene Villa",
    status: "Ongoing - Exterior Finishing",
    progress: 80,
    area: "2,750 sq.ft",
    bhk: "3 BHK Residence",
    image: VARK7,
    description: "Wake up to serene river breezes along Swamimalai Road. Crafted with natural granite stonework, expansive sit-out balconies, and serene temple views.",
    specs: ["River Breeze Orientation", "Granite Stonework", "Temple View Terraces", "Pure Well Water"]
  },
  {
    id: "trichy-thillai-nagar",
    title: "VARK Pearl Residences",
    city: "Trichy",
    subLocation: "Thillai Nagar",
    category: "Contemporary City Villa",
    status: "Ongoing - Structural Complete",
    progress: 70,
    area: "3,200 sq.ft",
    bhk: "4 BHK Villa",
    image: VARK8,
    description: "A commanding contemporary facade in Trichy's elite Thillai Nagar. High-tensile steel reinforcements, acoustic glass windows, and biometric digital door locks.",
    specs: ["Biometric Digital Access", "Acoustic Glazing", "2-Car Covered Porch", "Designer Modular Kitchen"]
  }
];

/**
 * 15 Curated High-Quality Gallery Snapshots with Aspect Ratios,
 * Detailed Descriptions, and Lightbox Metadata
 */
export const CURATED_GALLERY_IMAGES = [
  {
    id: 1,
    image: VARK1,
    title: "VARK Grand Luxury Villa",
    category: "Residential Elevation",
    location: "Surya Nagar, Madurai",
    aspect: "landscape",
    description: "Contemporary 4 BHK architectural luxury villa elevation with warm exterior LED illumination and manicured landscape."
  },
  {
    id: 2,
    image: VARK2,
    title: "Modern Duplex Villa Facade",
    category: "Architectural Exterior",
    location: "Oomachikulam, Madurai",
    aspect: "landscape",
    description: "Geometric architectural lines paired with stone accents and floor-to-ceiling glass paneling."
  },
  {
    id: 3,
    image: VARK3,
    title: "Signature Royal Residence",
    category: "Turnkey Construction",
    location: "RS Puram, Coimbatore",
    aspect: "landscape",
    description: "A grand multi-level luxury residence constructed with seismic-resistant RCC structural framing and Italian marble finishes."
  },
  {
    id: 4,
    image: VARK4,
    title: "Gated Community Enclave",
    category: "Villas & Township",
    location: "Saravanampatti, Coimbatore",
    aspect: "landscape",
    description: "Harmonious cluster of luxury residential homes with wide paved internal driveways and underground utility conduits."
  },
  {
    id: 5,
    image: VARK5,
    title: "Chola Heritage Fusion Villa",
    category: "Heritage Architecture",
    location: "Medical College Rd, Thanjavur",
    aspect: "landscape",
    description: "Traditional south Indian pillared verandah integrated with contemporary engineering durability and waterproof terrace seal."
  },
  {
    id: 6,
    image: VARK6,
    title: "Executive Modern Residence",
    category: "Urban Residential",
    location: "New Bus Stand, Thanjavur",
    aspect: "landscape",
    description: "Clean orthogonal geometry, cantilevered balconies, and premium weather-shield exterior coating."
  },
  {
    id: 7,
    image: VARK7,
    title: "Kaveri Riverview Duplex",
    category: "Scenic Living",
    location: "Swamimalai Rd, Kumbakonam",
    aspect: "landscape",
    description: "Serene residential retreat designed for maximum cross-ventilation and natural daylight ingress."
  },
  {
    id: 8,
    image: VARK8,
    title: "Pearl Contemporary Villa",
    category: "City Landmark",
    location: "Thillai Nagar, Trichy",
    aspect: "landscape",
    description: "Striking cantilevered structure with wooden louvers and custom powder-coated aluminum architectural fins."
  },
  {
    id: 9,
    image: VARK9,
    title: "VARK Diamond Villa",
    category: "Residential Architecture",
    location: "Avaniyapuram, Madurai",
    aspect: "landscape",
    description: "Crisp white minimalist elevation with charcoal stone highlights and recessed soffit spotlights."
  },
  {
    id: 10,
    image: VARK10,
    title: "Bespoke Independent Bungalow",
    category: "Luxury Living",
    location: "Thuvariman, Madurai",
    aspect: "landscape",
    description: "Custom turnkey bungalow crafted on a 3,000 sq.ft plot with open central living atrium."
  },
  {
    id: 11,
    image: VARK11,
    title: "Suburban Villa Landmark",
    category: "Villa Living",
    location: "Tirunagar, Madurai",
    aspect: "landscape",
    description: "Subtle earth-tone palette, expansive terrace sit-out pergolas, and heavy-gauge boundary security gating."
  },
  {
    id: 12,
    image: VARK12,
    title: "Architectural Symmetry Villa",
    category: "Modern Housing",
    location: "Gandhipuram, Coimbatore",
    aspect: "landscape",
    description: "Balanced dual-wing residential design ensuring complete Vastu compliance and acoustic peace."
  },
  {
    id: 13,
    image: MODERNHOUSE,
    title: "Modern Minimalist Landmark",
    category: "Signature Project",
    location: "Madurai Bypass Road",
    aspect: "landscape",
    description: "Award-winning ultra-modern villa design featuring dramatic floating roof planes and double-height glass entryway."
  },
  {
    id: 14,
    image: APPARTMENTS,
    title: "Multi-Storey Residential Heights",
    category: "Commercial & Residential",
    location: "Madurai City",
    aspect: "landscape",
    description: "Engineered multi-level apartment complex constructed with highest-grade structural steel and fire-retardant concrete."
  },
  {
    id: 15,
    image: INTERIOR,
    title: "Luxury Interior Craftsmanship",
    category: "Interior Works",
    location: "Executive Residence, Madurai",
    aspect: "landscape",
    description: "Bespoke interior execution showcasing false ceiling mood lighting, imported Italian marble, and custom acrylic modular kitchen."
  }
];

